// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pg7yhRjb__ProductName__styles-module__container___ZQWQ6gsZGzAdxFk_ {
    margin-bottom: 1.5rem;
}

.pg7yhRjb__ProductName__styles-module__name___m7kqxXV7dMQtbFy5 {
    text-align: left;
    margin-top: 0;
    margin-bottom: 0.875rem;
    font-weight: 400;
    font-size: 2rem;
    line-height: 1.12;
    color: var(--ds-color-text-main-onbrand);
}

.pg7yhRjb__ProductName__styles-module__description___c46VbgG8i9U7Pl7S {
    text-align: left;
    font: var(--ds-font-body-default-l);
    color: var(--ds-color-text-soft-onbrand);
}
`, "",{"version":3,"sources":["webpack://./src/modules/productInfo/components/ProductName/styles.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,wCAAwC;AAC5C","sourcesContent":[".container {\n    margin-bottom: 1.5rem;\n}\n\n.name {\n    text-align: left;\n    margin-top: 0;\n    margin-bottom: 0.875rem;\n    font-weight: 400;\n    font-size: 2rem;\n    line-height: 1.12;\n    color: var(--ds-color-text-main-onbrand);\n}\n\n.description {\n    text-align: left;\n    font: var(--ds-font-body-default-l);\n    color: var(--ds-color-text-soft-onbrand);\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `pg7yhRjb__ProductName__styles-module__container___ZQWQ6gsZGzAdxFk_`;
export var name = `pg7yhRjb__ProductName__styles-module__name___m7kqxXV7dMQtbFy5`;
export var description = `pg7yhRjb__ProductName__styles-module__description___c46VbgG8i9U7Pl7S`;
export default ___CSS_LOADER_EXPORT___;
